module.exports = __webpack_public_path__ + "img/publish.48fbeae2.png";